import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './OrderContent.module.scss';
import clsx from 'clsx';
import Block from '../Block/Block';
import Link from '../Link/Link';
import { imageUrl } from '../../utils/imageUrl';
import Button from '../Button/Button';
import { userChangeTransaction } from '../../redux/actions/user/userChangeTransaction';
import Alert from '../Alert/Alert';
import { useMediaQuery } from '../../utils/useMediaQuery';

export function sendMessageToParent(type, data) {
  if (window.opener) {
    window.opener.postMessage({ type, data }, '*');
    // Вместо '*' лучше указать конкретный origin для безопасности
    window.close();
  }
}
const OrderContent = ({ status, id, service, children, serviceGame, sumWithDiscount }) => {
  const dispatch = useDispatch();

  const {
    userChangeTransaction: { data: userChangeTransactionData, loading: userChangeTransactionLoading, error: userChangeTransactionError },
  } = useSelector((state) => state.user);
  useEffect(() => {
    if (userChangeTransactionData) {
      if (userChangeTransactionData?.status == 'CONFIRMED') {
        console.log('CONFIRM');

        sendMessageToParent('gamiPass:confirm', {
          transactionId: id,
          amount: 1000,
        });
      } else if (userChangeTransactionData?.status == 'CANCELED') {
        console.log('CANCELED');
        sendMessageToParent('gamiPass:canceled', {
          reason: 'user_cancelled',
        });
      }
    }
  }, [userChangeTransactionData]);

  const sumCells = (item) => {
    return (
      <>
        {' '}
        <div className={clsx(styles.sum)}>
          <div className={clsx(styles.sumValue)}>{item?.sum} ₽</div>
          <div className={clsx(styles.sumLabel)}>Сумма</div>
        </div>
        <div className={clsx(styles.sum)}>
          <div className={clsx(styles.sumValue)}>
            {item?.sumDiscount ? '-' : ''}
            {item?.sumDiscount} ₽
          </div>
          <div className={clsx(styles.sumLabel)}>Скидка {item?.percent}%</div>
        </div>
        <div className={clsx(styles.sum, styles.sumTotal)}>
          <div className={clsx(styles.sumValue)}>{item?.sumWithDiscount} ₽</div>
          <div className={clsx(styles.sumLabel)}>Итого</div>
        </div>
      </>
    );
  };

  const onChangeStatus = (status) => {
    dispatch(userChangeTransaction({ transactionId: id, status }));
  };
  const isMobile = useMediaQuery('(max-width:840px)');
  return (
    <>
      <Block
        title={
          <>
            Подтвердите скидку на сервисе
            <Link noLine className={clsx(styles.link)}>
              &nbsp;{service?.name}
            </Link>
          </>
        }
        className={clsx(styles.wrap)}
        classNameTitle={clsx(styles.title)}>
        {/* <div className={clsx(styles.text)}>Скидка на сервисе</div> */}
        <div className={clsx(styles.list)}>
          {/* {new Array(10).fill(children[0])?.map()} */}
          {children?.map((item, index) => (
            <>
              <div className={clsx(styles.number)}>{index + 1}</div> <img src={imageUrl(item?.serviceGame?.game?.logo)} alt="" className={clsx(styles.logo)} />
              <div className={clsx(styles.name)}>{item?.serviceGame?.game?.name}</div>
              <div>
                <div className={clsx(styles.playerId)}>{item?.playerId}</div>
              </div>
              {isMobile ? <div className={clsx(styles.sums)}>{sumCells(item)}</div> : sumCells(item)}
              <div className={clsx(styles.statusList)}>
                {item?.status == 'ERROR_PARTNER_NOT_ACTIVE_GAME' ? (
                  <div className={clsx(styles.status, styles.statusError, styles.statusPartner)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                    Игра неактивная
                  </div>
                ) : (
                  <>
                    <div className={clsx(styles.status, styles.statusSuccess, styles.statusPartner)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      Игра активная
                    </div>
                    {item?.status == 'SUCCESS_USER' ? (
                      <div className={clsx(styles.status, styles.statusSuccess)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        Игровой ID совподает
                      </div>
                    ) : item?.status == 'ERROR_USER_NOT_FOUND_GAME' ? (
                      <div className={clsx(styles.status, styles.statusError)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                        Игра не добавлена в вашем профиле{' '}
                      </div>
                    ) : item?.status == 'ERROR_USER_NOT_ACTIVE_GAME' ? (
                      <div className={clsx(styles.status, styles.statusError)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                        Игра не активировна у вас в профиле{' '}
                      </div>
                    ) : (
                      <div className={clsx(styles.status, styles.statusError)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                        Игровой ID несовподает{' '}
                      </div>
                    )}
                  </>
                )}
              </div>
              {children?.length - 1 !== index && <div className={clsx(styles.divider)}></div>}
            </>
          ))}
        </div>
        <div className={clsx(styles.footer)}>
          {status == 'ERROR_USER_CREATED' ? (
            <Alert type="error">
              Не получилось применить скидку <br /> Одна из игр у вас неактивна или несовпадает игровой ID c введеным в кабинете.
              <br /> Перейдите в <a>профиль</a> проверьте данные и попробуйте еще раз
            </Alert>
          ) : status == 'ERROR_PARTNER_CREATED' ? (
            <Alert type="error">Не получилось применить скидку. Данные игры не поддерживают скидку. Попробуйте добавить другие игры</Alert>
          ) : (
            <>
              {' '}
              <div className={clsx(styles.divider)}></div>
              <div className={clsx(styles.total)}>
                <div className={clsx(styles.totalLabel)}>Итого</div>
                <div className={clsx(styles.totalValue)}>{sumWithDiscount} ₽</div>
              </div>
            </>
          )}

          <div className={clsx(styles.actions)}>
            {status == 'CREATED_USER' ? (
              <>
                <Button
                  type="danger"
                  className={clsx(styles.btnCanceled)}
                  disabled={userChangeTransactionLoading}
                  onClick={() => {
                    onChangeStatus('CANCELED');
                  }}>
                  Отмена
                </Button>
                <Button
                  type="success"
                  className={clsx(styles.btnAccept)}
                  disabled={userChangeTransactionLoading}
                  onClick={() => {
                    onChangeStatus('CONFIRMED');
                  }}>
                  Подтвердить
                </Button>
              </>
            ) : status == 'ERROR_USER_CREATED' || status == 'ERROR_PARTNER_CREATED' ? (
              <Button
                type="success"
                className={clsx(styles.btnClose)}
                disabled={userChangeTransactionLoading}
                onClick={() => {
                  sendMessageToParent('gamiPass:error', {
                    reason: 'ERROR_USER',
                  });
                }}>
                Закрыть
              </Button>
            ) : (
              <></>
            )}
          </div>
        </div>
      </Block>
    </>
  );
};

export default OrderContent;
